export default __webpack_public_path__ + "static/media/billing-background-balance.a2267bef.png";